module.exports = __webpack_public_path__ + "static/media/avatars_male_24.03b0da84.png";